import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nazioni: [],
    riepilogo: {
      ref: "",
      refAIRBNB: "",
      refGuest: "",
      OraArrivo:"",
      ospite1: {
        cittadinanza: "",
        luogonascita: "",
        nome: "",
        cognome: "",
        datanascita: "",
        sesso: "",
        luogorilascio: "",
        tipodocumento: "",
        numerodocumento: "",
      },
      ospite2: {
        cittadinanza: "",
        luogonascita: "",
        nome: "",
        cognome: "",
        datanascita: "",
        sesso: "",
        luogorilascio: "",
        tipodocumento: "",
        numerodocumento: "",
      },
      ospite3: {
        cittadinanza: "",
        luogonascita: "",
        nome: "",
        cognome: "",
        datanascita: "",
        sesso: "",
        luogorilascio: "",
        tipodocumento: "",
        numerodocumento: "",
      },
      ospite4: {
        cittadinanza: "",
        luogonascita: "",
        nome: "",
        cognome: "",
        datanascita: "",
        sesso: "",
        luogorilascio: "",
        tipodocumento: "",
        numerodocumento: "",
      },
      ospite5: {
        cittadinanza: "",
        luogonascita: "",
        nome: "",
        cognome: "",
        datanascita: "",
        sesso: "",
        luogorilascio: "",
        tipodocumento: "",
        numerodocumento: "",
      },
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
